import ChildApi from 'web-app/api/child-api';
import {combineEpics} from 'web-app/util/redux-observable';

import {CANCELING_LEAVE_ACTION_TYPE, CONFIRM_LEAVE_ACTION_TYPE} from './action-types';
import * as Actions from './actions';

const confirmLeave = action$ =>
    action$
        .ofType(CONFIRM_LEAVE_ACTION_TYPE)
        .mergeMap(({payload}) =>
            ChildApi.changeStartAndEndDates(payload.childId, payload.startDate, payload.endDate).map(changedChild =>
                Actions.confirmLeaveSuccess.action({childId: changedChild.childId, endDate: payload.endDate}),
            ),
        );

const cancelLeave = action$ =>
    action$
        .ofType(CANCELING_LEAVE_ACTION_TYPE)
        .mergeMap(({payload}) =>
            ChildApi.changeStartAndEndDates(payload.childId, payload.startDate, payload.endDate).map(changedChild =>
                Actions.cancelLeaveSuccess.action({childId: changedChild.childId}),
            ),
        );

export default combineEpics(confirmLeave, cancelLeave);
